import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import LocalStorageManager from '../../utils/localStorage/manager';

export enum FavoritesActionKeys {
	TOGGLE_FAVORITE = '@@favorites/TOGGLE_FAVORITE',
	LOAD_FAVORITES = '@@favorites/LOAD_FAVORITES',
}

export type FavoritesListAction = ToggleFavoritesAction | LoadFavoritesAction;

interface ToggleFavoritesAction extends Action {
	type: FavoritesActionKeys.TOGGLE_FAVORITE;
	favoritesId: number[];
}

interface LoadFavoritesAction extends Action {
	type: FavoritesActionKeys.LOAD_FAVORITES;
	favoritesId: number[];
}

export const loadPreviousFavorites = () => (dispatch: Dispatch<StoreState>): void => {
	const previousFavorites = LocalStorageManager.getFavorites();
	if (previousFavorites) {
		dispatch({
			type: FavoritesActionKeys.LOAD_FAVORITES,
			favoritesId: previousFavorites,
		});
	}
};

export const toggleFavorite = (itemId: number) =>
	(dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {

	const { favorites } = getState();
	const isFavorite = favorites.includes(itemId);
	let newFavorites = favorites.slice(0);

	if (isFavorite) {
		newFavorites.splice(newFavorites.indexOf(itemId), 1);
	} else {
		newFavorites.push(itemId);
	}

	LocalStorageManager.setFavorites(newFavorites);

	dispatch({
		type: FavoritesActionKeys.TOGGLE_FAVORITE,
		favoritesId: newFavorites,
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Favorites/actions.ts